import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TableName } from "common/database-strings";
import { TableColumn } from "common/generator/description";
import { defaultRootState } from "./default-root-state";

const searchStateSlice = createSlice({
    name: "globalSearch",
    initialState: defaultRootState.search,
    reducers: {
        setShowSearch: (state, action: PayloadAction<boolean>) => {
            state.showSearch = action.payload;
        },
        setSearch: (
            state,
            { payload: { column, tableName } }: PayloadAction<{ column: TableColumn; tableName: TableName }>
        ) => {
            let childColumnNames: string[] | undefined;
            if (column.type.kind === "array" && column.type.itemColumnNames !== undefined) {
                childColumnNames = Array.from(column.type.itemColumnNames);
            }

            state.columnName = column.name;
            state.tableName = tableName;
            state.childColumnNames = childColumnNames;
            state.showSearch = true;
        },
    },
});

export const { setShowSearch, setSearch } = searchStateSlice.actions;
export default searchStateSlice.reducer;
